import { createAction, props } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { UserListActiveToggleOptions } from '../models/UserRegisterActiveToggleOptions.model';
import { UserRegisterListItem } from '../models/user-register-results.model';
import { UsersFilterOption } from '../models/users-filter-option';

const area = 'User Register';

export const userRegisterAdapterActions = createRegisterActions<UserRegisterListItem>(area);

export const userActiveToggle = createAction(
   `[${area}] Toggle user isActive`,
   props<{ userActiveToggleOptions: UserListActiveToggleOptions }>()
);

export const userActiveToggleSuccess = createAction(
   '[API] User isActive Toggle Success',
   props<{ userActiveToggleOptions: UserListActiveToggleOptions }>()
);

export const userActiveToggleFailure = createAction('[API] User isActive Toggle Failure', props<SingleGraphError>());

export const userRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: UsersFilterOption[] }>()
);

export const roleUsersInitialQuickFilter = createAction(`[${area}] Role Users Initial Quick Filter`);

export const loadSystemUsersSuccess = createAction(`[System ${area}] Register Load Success`);

export const loadAccountUsersSuccess = createAction(`[Account ${area}] Register Load Success`);

export const createUser = createAction('[User Register] Create User');

export const setOrderingOptionsFromSessionStorage = createAction(
   `[${area}] Set Ordering Options From Session Storage`,
   props<{ orderingOptions: OrderingOption[] | null }>()
);
